import React, { useRef, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { classnames } from '../../../helpers/classnames';
import styles from './IframeViewer.css';
import { bem } from '../../../helpers/styles';
import useTranslate from '../../../hooks/useTranslate';
import Error from '../../atoms/Error/Error';
import { URL_REGEX } from '../../../constants/regex';
function IframeViewer({ link, style, className, fixedMode }) {
  const i18n = useTranslate();
  const ref = useRef(null);
  const [styleOverride, setStyle] = useState(null);
  const error = useMemo(() => link.match(URL_REGEX) === null);

  const finalStyle = useMemo(
    () =>
      fixedMode && styleOverride
        ? {
            ...style,
            position: 'fixed',
            ...styleOverride,
          }
        : style,
    [style, styleOverride],
  );

  // En fixedMode on retaille le div principal pour "rentrer" dans le div parent
  // https://stackoverflow.com/questions/5873565/set-width-of-a-position-fixed-div-relative-to-parent-div
  useEffect(() => {
    if (!fixedMode || !ref.current?.parentNode) {
      return;
    }

    const updateStyle = () => {
      if (!ref.current?.parentNode) return;
      const { clientWidth, clientHeight } = ref.current.parentNode;
      setStyle({
        ...style,
        width: clientWidth - 16,
        height: clientHeight - 16,
      });
    };
    updateStyle();

    // ResizeObserver pour observer les changements de taille du parent
    const resizeObserver = new ResizeObserver(updateStyle);
    resizeObserver.observe(ref.current?.parentNode);

    return () => {
      resizeObserver.disconnect();
    };
  }, [fixedMode, style]);

  if (error) return <Error>{i18n('IframeViewer.error.description')}</Error>;
  return (
    <div style={finalStyle} className={classnames([styles.IframeViewer, className])} ref={ref}>
      <iframe
        className={bem(styles, 'IframeViewer__iframe', { fixedMode })}
        src={link}
        tabIndex={-1}
      />
    </div>
  );
}

IframeViewer.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string.isRequired,
  style: PropTypes.object,
  fixedMode: PropTypes.bool,
};

export default IframeViewer;
